
import { clinicService } from "@/domain/services";
import { defineComponent } from "vue";
import { mapState, mapActions } from "vuex";

export default defineComponent({
  name: "ClinicList",
  computed: {
    ...mapState("clinics", ["clinics", "isLoading"]),
  },
  created() {
    this.loadClinics();
  },
  methods: {
    deleteClinic(id: number) {
      if (confirm("Você realmente deseja deletar essa clínica?")) {
        clinicService.deleteById(id).then(() => {
          this.loadClinics();
        });
      }
    },
    ...mapActions({ loadClinics: "clinics/load" }),
  },
});
